
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">微信公众号如何生成追踪来源的二维码？</div>
      <div class="panel-body">
        <span
          class="span1"
        >微信公众号怎么生成能追踪来源的渠道二维码？很多商家在做广告活动推广自己的微信公众号时往往苦于不知道渠道来源，比如有家蛋糕店在周围各个小区电梯里都张贴了自己的宣传海报，但是对于各个小区的吸粉情况却一无所知，下次为保证效果还得全部投放，但是这样一来可能会浪费一定的广告费用，不利于小店的经营。</span>
        <p
          class="span1"
        >现在只需要针对各个渠道生成不同的二维码就可以轻松解决这个问题啦，店家可以在客服系统后台实时观察每个渠道的吸粉情况，哪个小区粉丝多，哪个少，一目了然。下次投放广告也可以针对性的在粉丝多的小区搞一些特色优惠活动，这样不经增加了营业额，还能提高粉丝的忠诚度和认同感。那么，微信公众号怎么生成能追踪来源的渠道二维码？</p>
        <p class="p1">解决方法</p>
        <p class="span1">
          1、首先注册申请汇客软件账号，把自己的公众号接入汇客软件微客服系统；
          <br />2、其次登陆汇客软件账号，进入【微信营销平台】点击已绑定的微信公众号；
          <br />3、在后台找到推广功能下的【渠道二维码】并点击
          <br />4、选择【新建渠道二维码】根据需要完成各项填写并保存
        </p>
        <p class="span1">这样渠道二维码就创建好了，大家可以在自己的海报张贴不同的二维码来统计效果，吸粉情况在汇客软件微客服后台可以清楚的看到。</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


